import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { LogoLink } from '../../shared/LogoLink';
import { HeaderSharedStyles, HeaderWedge } from './HeaderSharedStyles';
export const HeaderWithCenteredLogo = () => {
    return (_jsxs(HeaderWithCenteredLogoRoot, { children: [_jsx(LogoLink, {}), _jsx(HeaderWedge, {})] }));
};
const HeaderWithCenteredLogoRoot = styled.div `
    ${HeaderSharedStyles}
    align-items: center;
    display: flex;
    justify-content: center;
`;
